export default "__VITE_ASSET__B4fR0rro__ 640w, __VITE_ASSET__C4vdpirQ__ 1024w";